import { useForm } from 'react-hook-form';
import { Button, Form } from 'react-bootstrap';
import { yupResolver } from '@hookform/resolvers/yup';
import SearchIcon from '@mui/icons-material/Search';
import { handleBuscarActasPorArticulo } from './handlers';
import { buscarActaPorArticulosSchema } from './schemas';
import DateInput from '../../components/ReactHookForm/DateInput';
import MuniSpinner from '../../components/MuniSpinner';

const FormBuscarActasPorArticulo = (props) => {
  const { setData, setFechasBusqueda } = props

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(buscarActaPorArticulosSchema),
  });

  return (
    <Form onSubmit={handleSubmit((data) => handleBuscarActasPorArticulo(data, setData, setFechasBusqueda))} style={{ maxWidth: '320px' }}>
      <fieldset disabled={isSubmitting}>
        <div className="d-flex flex-column">
          <DateInput label="Fecha de Inicio *" name="fecha_inicio" register={register} errors={errors?.fecha_inicio} />

          <DateInput label="Fecha Fin *" name="fecha_fin" register={register} errors={errors?.fecha_fin} />

          <Button
            type="submit"
            className="mt-2"
            disabled={isSubmitting}
            style={{ height: '38px', alignSelf: 'flex-middle' }}
          >
            {isSubmitting ? (
              <MuniSpinner
                width="18px"
                height="18px"
                circularProgressSize={24}
                circularProgressColor="#ffffff"
                fileName="bola-blanca.png"
              />
            ) : (
              <>
                <SearchIcon /> Consultar
              </>
            )}
          </Button>
        </div>
      </fieldset>
    </Form>
  );
};

export default FormBuscarActasPorArticulo;
